export const USERNAME_PROFILE = "EdwBaeza";
export const BASE_URL = "https://api.github.com/";
export const REPOSITORIES_URL = `${BASE_URL}users/${USERNAME_PROFILE}/repos`;



// WEBPACK FOOTER //
// ./src/constants/github.js